export enum ApplicationEnum {
    USAR_CANTIDAD_CONCESION = 'USAR_CANTIDAD_CONCESION',
    ACOTAR_EN_INCREMENTO = 'ACOTAR_EN_INCREMENTO'
}